export * from './material-icons';
export * from './font-awesome-icons';
export * from './font-awesome-icon-type.enum';
export * from './font-awesome-icon-type-button-config';
export * from './ng-zorro-icons';
export * from './ng-zorro-icon-type-button-config';
export * from './font-awesome-icon-style-option-config';
export * from './ng-zorro-icon-theme-option-config';
export * from './font-awesome-icon-animation-option-config';
